import { render, staticRenderFns } from "./MsgWindow.vue?vue&type=template&id=4949176c&scoped=true"
import script from "./MsgWindow.vue?vue&type=script&lang=js"
export * from "./MsgWindow.vue?vue&type=script&lang=js"
import style0 from "./MsgWindow.vue?vue&type=style&index=0&id=4949176c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949176c",
  null
  
)

export default component.exports